import React, {Component} from 'react';

import 'sass/payment/PaymentOptionRadio.scss';
import {formatAmount} from '../../utils/payment';

import {t, dt} from 'l10n';

const PaymentOptionRadio = ({value, name, group='', checked, price, freePoints, onSelect}) => (
    <div className={'radio-stylized payment-option-radio' + (checked ? ' selected' : '')} style={{display: name === 'néant' ? 'none' : 'block'}} onClick={() => onSelect(value)}>
        <input type="radio" name={group ? group : "t"} id={`payment-radio-${group}-${value}`} value={value} checked={checked} readOnly/>
        <label htmlFor={`payment-radio-${group}-${value}`}>{name}{price ? ` / ` : ''}{!!price && <strong>{formatAmount(price)}</strong>}</label>
    </div>
);

export default PaymentOptionRadio;


// WEBPACK FOOTER //
// ./src/components/payment/PaymentOptionRadio.js